export const EASE_OUT = 'cubic-bezier(0.23, 1, 0.32, 1)';
export const EASE_IN_OUT = 'cubic-bezier(0.65, 0, 0.35, 1)';
export const EASE_DRAWER = 'cubic-bezier(0.32, 0.72, 0, 1)';
export const EASE_POP = 'cubic-bezier(0.34, 1.36, 0.64, 1)';
